import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";


const Terms = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="terms-page">
      <section className="py-16 lg:py-24 bg-white border-b">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back to Home */}
          <Link to="/" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 mb-6 text-sm font-medium">
            ← Back to Home
          </Link>
          
          <Badge className="bg-slate-100 text-slate-700 mb-4">Legal</Badge>
          <h1 className="text-4xl font-heading font-bold text-navy-700 mb-4">
            Terms of Service
          </h1>
          <p className="text-slate-500">Last updated: January 2025</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card className="border-0 shadow-card">
            <CardContent className="prose prose-slate max-w-none p-8">
              <h2>1. Acceptance of Terms</h2>
              <p>
                By accessing and using the Compoundr website, you accept and
                agree to be bound by these Terms of Service. If you do not
                agree to these terms, please do not use our services.
              </p>

              <h2>2. Educational Content Only</h2>
              <p>
                <strong>Important:</strong> Compoundr provides educational
                content only. We are not licensed financial advisors, and
                nothing on this website constitutes personalized financial
                advice.
              </p>
              <p>
                The information provided is for general educational purposes
                and should not be considered as investment advice. Always
                consult with a licensed financial professional before making
                investment decisions.
              </p>

              <h2>3. No Guarantees</h2>
              <p>
                We do not guarantee any specific investment outcomes. Past
                performance does not guarantee future results. Investing
                involves risk, including the potential loss of principal.
              </p>

              <h2>4. User Responsibilities</h2>
              <p>By using our services, you agree to:</p>
              <ul>
                <li>Provide accurate information when registering</li>
                <li>Use our services for lawful purposes only</li>
                <li>Not share your account credentials</li>
                <li>Conduct your own research before investing</li>
              </ul>

              <h2>5. Intellectual Property</h2>
              <p>
                All content on this website, including text, graphics, logos,
                and images, is the property of Compoundr and is protected
                by copyright laws.
              </p>

              <h2>6. Third-Party Links</h2>
              <p>
                Our website may contain links to third-party websites. We are
                not responsible for the content or practices of these sites.
              </p>

              <h2>7. Limitation of Liability</h2>
              <p>
                Compoundr shall not be liable for any direct, indirect,
                incidental, or consequential damages arising from your use of
                our services or reliance on our content.
              </p>

              <h2>8. Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time.
                Continued use of our services after changes constitutes
                acceptance of the new terms.
              </p>

              <h2>9. Governing Law</h2>
              <p>
                These terms are governed by the laws of Canada and the province
                of Ontario.
              </p>

              <h2>10. Contact</h2>
              <p>
                For questions about these Terms, contact us at
                hello@newinvestors.ca.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>

      
    </div>
  );
};

export default Terms;
